<template>
    <mu-button @click="exportExcel" :color="color || 'primary'" :round="round ? round : false">
        <slot></slot>
    </mu-button>
</template>

<script>
    import XLSX from 'xlsx/xlsx'

    export default {
        name: 'mu-xlsx',
        props: ['columns', 'data', 'filename', 'sheetname', 'color', 'round'],
        methods: {
            exportExcel () {
                let createXLSLFormatObj = []
                let newXlsHeader = []
                let vm = this

                if (vm.columns.length === 0) {
                    return
                }

                if (vm.data.length === 0) {
                    return
                }

                for (const item of vm.columns) {
                    newXlsHeader.push(item.label)
                }

                createXLSLFormatObj.push(newXlsHeader)

                for (const value of vm.data) {
                    let innerRowData = []
                    for (const val of vm.columns) {
                        if (val.dataFormat && typeof val.dataFormat === 'function') {
                            innerRowData.push(val.dataFormat(value[val.field]))
                        } else {
                            innerRowData.push(value[val.field])
                        }
                    }
                    createXLSLFormatObj.push(innerRowData)
                }

                let filename = vm.filename + '.xlsx'
                let wsName = vm.sheetname
                let wb = XLSX.utils.book_new()
                let ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj)

                XLSX.utils.book_append_sheet(wb, ws, wsName)
                XLSX.writeFile(wb, filename)
            }
        }
    }
</script>
